import Link from 'next/link'
import { route as makeUrl } from 'themes/route'
import Layout from 'themes/layouts/Home'
import { DatePicker, message } from 'antd';
import { Button, Row, Col, Typography, Form, Input} from 'antd';
const { Title } = Typography
import useBaseHook from 'themes/hooks/BaseHooks'


export default () => {
  const {t} = useBaseHook()
  return <Layout>
  <div id="bannerHeaderHome">
    <div className="container">
      <Row>
        <Col lg={12} xl={12}>
        <div className="contentTextInfoHeader">
          <h3><span className="lineTop"></span>{t("home.location.subTitle")}</h3>
          <h1>{t("home.location.title")}</h1>
          <h2>{t("home.location.description")}</h2>
          <Button className="resAccountMqn">{t("home.location.createAccount")}</Button>
          <Button className="contactSale">{t("home.location.contactSale")}</Button>
        </div>
        </Col>
        <Col lg={12} xl={12}>
        <div className="imgHeader">
          <img src="/static/img/section-inventory.png" alt="dohu.vn" />
        </div>
        </Col>
      </Row>
    </div>
  </div>

  <div id="bannerIndoorMainMqn">
    <div className="container">
      <div className="titleIndoor">
        <h1>{t("home.location.indoorExchange")}</h1>
        <p>{t("home.location.indoorExchangeDescription")}</p>
        <img src="/static/img/iconLine.PNG" alt="dohu.vn" />
      </div>
      <div className="itemIndoor">
        <Row gutter={24}>
          <Link {...makeUrl("frontend.home.detailLocation")}>
            <Col lg={12} xl={12}>
            <div className="itemIndoor">
              <div className="ImgInodorMqn">
                <img src="/static/img/tat-tan-tat-ve-quang-cao-man-hinh-lcd-frame-thang-may-6.jpg" alt="dohu.vn" />
              </div>
                <Row>
                  <Col span={7}>
                  <div className="itemIconContentIndoor">
                    <h1>{t("home.location.livingRoom")}</h1>
                  </div>
                  </Col>
                  <Col span={6}>
                  <div className="itemIconContentIndoor">
                    <img src="/static/img/user.svg" alt="dohu.vn" />
                    <p>2M</p>
                  </div>
                  </Col>
                  <Col span={6}>
                  <div className="itemIconContentIndoor">
                    <img src="/static/img/map.svg" alt="dohu.vn" />
                    <p>600</p>
                  </div>
                  </Col>
                  <Col span={5}>
                  <div className="itemIconContentIndoor">
                    <img src="/static/img/screen.svg" alt="dohu.vn" />
                    <p>1000</p>
                  </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Link>
          {/* Item 2 */}
          <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/lap-dat-200-smart-tivi-phuc-vu-benh-nhan-don-tet.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1>{t("home.location.office")}</h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>{t("home.location.office")}</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>600</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>2,7000</p>
              </div>
              </Col>
            </Row>
          </div>
          </Col>
          {/* End item 2 */}

          {/* Item 3 */}
          <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/benh-nhan-quan-sat-noi-dung-tren-man-hinh-quang-cao.jpeg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1>{t("home.location.hospital")}</h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>2M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>600</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>1000</p>
              </div>
              </Col>
            </Row>
          </div>
          </Col>
          {/* End item 3 */}


          {/* Item 4 */}
          <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/quan-an.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1>{t("home.location.restaurant")}</h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>16.7M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>700</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>700</p>
              </div>
              </Col>
            </Row>
          </div>
          </Col>
          {/* End item 4 */}

          {/* Item 6 */}
          <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/bien-quang-cao-aeon-768x727.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1>{t("home.location.supermarket")}</h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>2M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>600</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>1000</p>
              </div>
              </Col>
            </Row>
          </div>
          </Col>
          {/* End item 6 */}

          {/* Item 6 */}
          <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/man-hinh-quang-cao-quan-cafe.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1>{t("home.location.station")}</h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>233M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>200</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>660</p>
              </div>
              </Col>
            </Row>
          </div>
          </Col>
          {/* End item 6 */}
        </Row>
      </div>

      <div className="titleIndoor">
        <h1>{t("home.location.outdoorExchange")}</h1>
        <p>{t("home.location.outdorExchangeDescription")}</p>
        <img src="/static/img/iconLine.PNG" alt="dohu.vn" />
      </div>
      <Row gutter={24}>
        <Col lg={12} xl={12}>
        <div className="itemIndoor">
          <div className="ImgInodorMqn">
            <img src="/static/img/ban_ve_bien_quang_cao_tam_lon_4.jpg" alt="dohu.vn" />
          </div>
          <Row>
            <Col span={7}>
            <div className="itemIconContentIndoor">
              <h1>{t("home.location.highway")}</h1>
            </div>
            </Col>
            <Col span={6}>
            <div className="itemIconContentIndoor">
              <img src="/static/img/user.svg" alt="dohu.vn" />
              <p>302M</p>
            </div>
            </Col>
            <Col span={6}>
            <div className="itemIconContentIndoor">
              <img src="/static/img/map.svg" alt="dohu.vn" />
              <p>300</p>
            </div>
            </Col>
            <Col span={5}>
            <div className="itemIconContentIndoor">
              <img src="/static/img/screen.svg" alt="dohu.vn" />
              <p>300</p>
            </div>
            </Col>
          </Row>
        </div>
        </Col>

        <Col lg={12} xl={12}>
        <div className="itemIndoor">
          <div className="ImgInodorMqn">
            <img src="/static/img/image001-1559289332-7628-1559289425_1200x0.jpg" alt="dohu.vn" />
          </div>
          <Row>
            <Col span={7}>
            <div className="itemIconContentIndoor">
              <h1><h1>{t("home.location.outside")}</h1></h1>
            </div>
            </Col>
            <Col span={6}>
            <div className="itemIconContentIndoor">
              <img src="/static/img/user.svg" alt="dohu.vn" />
              <p>97.6M</p>
            </div>
            </Col>
            <Col span={6}>
            <div className="itemIconContentIndoor">
              <img src="/static/img/map.svg" alt="dohu.vn" />
              <p>300</p>
            </div>
            </Col>
            <Col span={5}>
            <div className="itemIconContentIndoor">
              <img src="/static/img/screen.svg" alt="dohu.vn" />
              <p>410</p>
            </div>
            </Col>
          </Row>
        </div>
        </Col>

        <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/downtow.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1><h1>{t("home.location.downtown")}</h1></h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>97.6M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>300</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>410</p>
              </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/Swisstouches-LaLuna-Resort-quang-cao-bien-hop-den-1-1067x800.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1><h1>{t("home.location.airport")}</h1></h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>97.6M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>300</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>410</p>
              </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/bang-hieu-me-va-be-2.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1><h1>{t("home.location.playground")}</h1></h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>97.6M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>300</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>410</p>
              </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/bi-to-de-quen-dung-cu-y-te-trong-co-the-benh-nhan-lanh-dao-benh-vien-thanh-nhan-noi-gi-203208.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1><h1>{t("home.location.outsideHospital")}</h1></h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>97.6M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>300</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>410</p>
              </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/quang-cao-man-hinh-led-ngoai-troi.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1><h1>{t("home.location.outsideOffice")}</h1></h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>97.6M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>300</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>410</p>
              </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col lg={12} xl={12}>
          <div className="itemIndoor">
            <div className="ImgInodorMqn">
              <img src="/static/img/panoquangcao4_1585971025.jpg" alt="dohu.vn" />
            </div>
            <Row>
              <Col span={7}>
              <div className="itemIconContentIndoor">
                <h1><h1>{t("home.location.overpass")}</h1></h1>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/user.svg" alt="dohu.vn" />
                <p>97.6M</p>
              </div>
              </Col>
              <Col span={6}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/map.svg" alt="dohu.vn" />
                <p>300</p>
              </div>
              </Col>
              <Col span={5}>
              <div className="itemIconContentIndoor">
                <img src="/static/img/screen.svg" alt="dohu.vn" />
                <p>410</p>
              </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  </div>


  <div id="speccificationMqnMain">
    <div className="container">
      <div className="titleSpec">
        <h3><span className="lineTop"></span>{t("home.location.subTitle")}</h3>
        <h1>{t("home.location.different")}</h1>
        <h2>{t("home.location.differentDescription")}</h2>
        <div className="tableMainWhiteSpec">
          <table className="table is-fullwidth" style={{borderRadius: "2em"}}>
            <thead>
              <tr>
                <th style={{width:"13%"}}></th>
                <th style={{width:"29%"}}>
                  <div className="is-vcentered">
                    <span className="icon is-large">
                      <img src="/static/img/exchange-place-based.svg" />
                    </span>
                    <span className="title is-3 is-bold">{t("home.location.indoorExchange")}</span>
                  </div>
                </th>
                <th style={{width:"29%"}}>
                  <div className="is-vcentered">
                    <span className="icon is-large">
                      <img src="/static/img/exchange-outdoor.svg" />
                    </span>
                    <span className="title is-3 is-bold">{t("home.location.outdoorExchange")}</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="borderTopTbody">
              <tr>
                <th>{t("home.location.creative")}</th>
                {/* Images */}

                <table>
                  <td style={{width:"50%"}}>
                    <table className="table is-narrow is-full">
                      <thead>
                        <tr>
                          <th>
                            <h3 className="title is-3 is-marginless">{t("home.location.image")}</h3>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>{t("home.location.format")}</th>
                          <td style={{width:"100%"}}>.jpg, .png</td>
                        </tr>
                        <tr>
                          <th>{t("home.location.dimension")}</th>
                          <td>
                            <div>1920 x 1080px</div>
                            <div>1080 x 1920px</div>
                          </td>
                        </tr>
                        <tr>
                          <th>{t("home.location.duration")}</th>
                          <td>
                            <div>{t("home.location.durationContent1")}</div>
                            <small className="is-grey">{t("home.location.durationContent2")}</small>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </table>

                {/* End imgages */}
                {/* item 2 */}
                <table>
                  <td style={{width:"50%"}}>
                    <table className="table is-narrow">
                      <thead>
                        <tr>
                          <th>
                            <h3 className="title is-3 is-marginless">{t("home.location.video")}</h3>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>{t("home.location.format")}</th>
                          <td style={{width:"100%"}}>.mp4, .mov, .webm</td>
                        </tr>
                        <tr>
                          <th>{t("home.location.dimension")}</th>
                          <td>
                            <div>1920 x 1080px</div>
                            <div>1080 x 1920px</div>
                          </td>
                        </tr>
                        <tr>
                          <th>{t("home.location.fileSize")}</th>
                          <td>{t("home.location.fileSizeContent")}</td>
                        </tr>
                        <tr>
                          <th>{t("home.location.duration")}</th>
                          <td>{t("home.location.durationContent1")}</td>
                        </tr>
                        <tr>
                          <th>{t("home.location.audio")}</th>
                          <td>{t("home.location.audioContent1")} <br /><small className="is-grey">{t("home.location.audioContent2")}</small></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </table>
                {/* item 3 */}

                <td>
                  <table className="table is-narrow is-full">
                    <thead>
                      <tr>
                        <th>
                          <h3 className="title is-3 is-marginless">{t("home.location.image")}</h3>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>{t("home.location.format")}</th>
                        <td style={{width:"100%"}}>.jpg, .png</td>
                      </tr>
                      <tr>
                        <th>{t("home.location.dimension")}</th>
                        <td>
                          <ul style={{listStyle: "none", marginBottom: "1em"}}>
                            <li>1920 x 1080px</li>
                            <li>1288 x 616px</li>
                            <li>1408 x 400px</li>
                            <li>1152 x 476px</li>
                            <li>544 x 176px</li>
                            <li>384 x 288px</li>
                            <li>1080 x 1920px</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <small className="is-grey">{t("home.location.creativeCan")}</small>
                </td>
              
              {/* item 4 */}

              </tr>
            </tbody>
            <tbody className="borderTopTbody">
              <tr>
                <th>{t("home.location.screenSize")}</th>
                <td>
                  <ul style={{listStyle: "none", marginBottom: "1em"}}>
                    <li><strong>{t("home.location.tvFormat")}</strong></li>
                    <li>{t("home.location.tvFormatDescription1")}</li>
                  </ul>
                </td>
                <td>
                  <ul style={{listStyle: "none", marginBottom: "1em"}}>
                    <li><strong>{t("home.location.tvFormat")}</strong></li>
                    <li>{t("home.location.tvFormatDescription2")}</li>
                  </ul>
                  <ul style={{listStyle: "none", marginBottom: "1em"}}>
                    <li><strong>{t("home.location.billboardFormat")}</strong></li>
                    <li>{t("home.location.billboardDescription1")}</li>
                    <small className="is-grey">{t("home.location.billboardDescription2")}</small>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</Layout>
}
